import { Link } from 'react-router-dom';
import type { ArticleDetail } from '@/mocks/article';

interface DetailHeroProps {
  article: ArticleDetail;
}

export default function DetailHero({ article }: DetailHeroProps) {
  return (
    <section className="relative w-full h-[420px] md:h-[550px] overflow-hidden">
      <img
        src={article.heroImage}
        alt={article.title}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/55"></div>

      <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-end pb-14 md:pb-18">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-4 flex-wrap">
            <span className="inline-block px-3 py-1 border border-accent-400/60 rounded-full text-accent-300 text-xs font-medium">
              {article.status}
            </span>
            <Link
              to={`/category/${article.categorySlug}`}
              className="inline-block px-3 py-1 border border-white/30 rounded-full text-white/80 text-xs hover:border-white/60 transition-colors"
            >
              {article.category}
            </Link>
            {article.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="text-white/50 text-xs">{tag}</span>
            ))}
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-3">
            {article.title}
          </h1>

          <div className="flex items-center gap-3 text-white/60 text-sm flex-wrap">
            <span>{article.author}</span>
            <span className="w-1 h-1 rounded-full bg-white/40"></span>
            <span>共 {article.chapters} 话</span>
            <span className="w-1 h-1 rounded-full bg-white/40"></span>
            <span>更新于 {article.updateTime}</span>
          </div>
        </div>
      </div>
    </section>
  );
}